import secureApi from "../services/secureApi";
// Get Staff List
export const getStaffListApi = async () => {
  try {
    const payload = {
      role: "STAFF"
    };
    const response = await secureApi.post(
      "/admin/staff/list",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Staff List Error:", error);
    throw error;
  }
};
// Get Admin List
export const getAminListApi = async () => {
  try {
    const payload = {
      role: "ADMIN"
    };
    const response = await secureApi.post(
      "/admin/staff/list",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Admin List Error:", error);
    throw error;
  }
};
// Get Staff By ID
export const getStaffByIdApi = async (staffId) => {
  try {
    const response = await secureApi.get(
      `/admin/staff/view/${staffId}`
    );
    return response.data;
  } catch (error) {
    console.error("Get Staff Error:", error);
    throw error;
  }
};
// Add Staff
export const addStaffApi = async (data) => {
  try {
    const response = await secureApi.post(
      "/admin/staff/add",
      data
    );
    return response.data;
  } catch (error) {
    console.error("Add Staff Error:", error);
    throw error;
  }
};
// Update Staff
export const updateStaffApi = async (staffId, data) => {
  try {
    const response = await secureApi.put(
      `/admin/staff/edit`,
      {
        staffId: staffId,
        ...data
      }
    );
    return response.data;
  } catch (error) {
    console.error("Update Staff Error:", error);
    throw error;
  }
};